import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { ComponentLoader } from 'components';
import { urls } from 'features/common/fetch/constants';
import { getSortedTasksInfosLeadsByNotificationSetId } from 'features/views/settings/selectors';

import InformationSettings from './components/InformationSettings';
import LeadsSettings from './components/LeadsSettings';
import TasksSettings from './components/TasksSettings';

export const CustomSettings = ({ notificationSetId }) => {
	const {
		tasks = [],
		information = [],
		leads = [],
	} = useSelector((state) => getSortedTasksInfosLeadsByNotificationSetId(state, notificationSetId));

	return (
		<ComponentLoader fetchStorePath={urls.userNotificationSettings}>
			<Stack spacing={3}>
				{!isEmpty(tasks) && <TasksSettings tasks={tasks} />}
				{!isEmpty(information) && <InformationSettings information={information} />}
				{!isEmpty(leads) && <LeadsSettings leads={leads} />}
			</Stack>
		</ComponentLoader>
	);
};

CustomSettings.propTypes = {
	notificationSetId: PropTypes.number,
};

export default CustomSettings;
